import React from "react";
import swal from "sweetalert";
import { useSave } from "seed/gql";
import { SAVE_FLOW_PAGE } from "seed/gql/queries";
import l from "components/util/l";
import View from "components/studio/forms/pages/PageFormView.view";

function PageFormCreate({ match }) {

  const flowId = match?.params?.flowId;

  const [callSave] = useSave(SAVE_FLOW_PAGE, {
    onCompleted: (data) => {
      sessionStorage.setItem("page_" + flowId, data.saveFlowPage.flowPage.id);
      window.location.replace(`/app/studio/${flowId}`);
    }, onError: () => {
      swal({ title: l("Error al crear la página%SA204"), text: l("Por favor cierra sesión y vuelva a entrar"), icon: "error" });
    }
  })

  const onSubmit = (values) => {

    const newValues = {
      name: values.name,
      isDefault: false,
      flow: parseInt(flowId)
    }

    callSave(newValues);
  }

  return <View onSubmit={onSubmit} />;
}

export default PageFormCreate;